var map = {
	"./TetraPakTCS/Data/Locales/en.json": [
		6434,
		6434
	],
	"./TetraPakTCS/Data/Pages/about.json": [
		8441,
		8441
	],
	"./TetraPakTCS/Data/Pages/maintenance.json": [
		5671,
		5671
	],
	"./TetraPakTCS/Data/Pages/support.json": [
		199,
		199
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 366;
module.exports = webpackAsyncContext;